<template functional>
    <svg class="tw-opacity-50 tw--ml-3" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 317.9 317.9" style="enable-background:new 0 0 317.9 317.9;" xml:space="preserve">
        <g>
	<g>
		<path class="st3" d="M147.9,156.6h86c12.2,0,22.1,9.9,22.1,22.1v46.4c0,11.5-8.7,20.9-19.9,22c-1.1,11.1-10.7,26.6-10.7,26.6
			c0-15.9-12.6-26.5-12.6-26.5h-64.8c-12.2,0-22.1-9.9-22.1-22.1v-46.4C125.8,166.5,135.7,156.6,147.9,156.6z"/>
        <circle class="st2" cx="190.9" cy="201.5" r="7.1"/>
        <circle class="st2" cx="221.9" cy="201.5" r="7.1"/>
        <circle class="st2" cx="159.9" cy="201.5" r="7.1"/>
	</g>
            <path class="st6" d="M171.9,146.3h-86c-12.2,0-22.1,9.9-22.1,22.1v46.4c0,11.5,8.7,20.9,19.9,22c1.1,11.1,10.7,26.6,10.7,26.6
		c0-15.9,12.6-26.5,12.6-26.5h64.8c12.2,0,22.1-9.9,22.1-22.1v-46.4C194,156.2,184.1,146.3,171.9,146.3z"/>
            <circle class="st11" cx="128.9" cy="191.2" r="7.1"/>
            <circle class="st11" cx="97.9" cy="191.2" r="7.1"/>
            <circle class="st11" cx="159.9" cy="191.2" r="7.1"/>
</g>
        <g>
	<g>
		<path class="st2" d="M177.8,94.2c1.5-1.6,3.5-2.4,5.8-2.4c6,0,10.8-1.4,14.4-4.2c3.6-2.8,5.4-7.2,5.4-13c0-4.5-1.6-8.3-4.9-11.3
			c-3.3-3-7.3-4.5-12.2-4.5c-5,0-9.4,1.7-13.2,5c-2.2,2-4.4,3-6.8,3c-1.7,0-3.3-0.5-4.6-1.6c-2.4-1.8-3.5-3.9-3.5-6.4
			c0-2.1,0.9-4,2.6-5.7c3.3-3.3,7.1-6,11.5-7.8c4.4-1.9,9.1-2.8,14.1-2.8c6.2,0,11.8,1.4,16.8,4.2c5.1,2.8,9.1,6.7,12.1,11.6
			c3,4.9,4.5,10.3,4.5,16.2c0,8.7-2.5,15.6-7.5,20.6c-5,5.1-11.6,8.2-19.8,9.5c-0.5,0.2-0.7,0.4-0.7,0.7v5c0,2.4-0.8,4.3-2.3,5.9
			c-1.5,1.6-3.5,2.4-5.8,2.4c-2.4,0-4.3-0.8-5.8-2.4c-1.5-1.6-2.3-3.6-2.3-5.9v-10.3C175.5,97.7,176.3,95.8,177.8,94.2z M177,140.9
			c-1.4-1.4-2.1-3.4-2.1-6v-2.3c0-2.6,0.7-4.6,2.1-6c1.4-1.4,3.4-2.1,6-2.1h1.8c2.6,0,4.6,0.7,6,2.1c1.4,1.4,2.1,3.4,2.1,6v2.3
			c0,2.6-0.7,4.6-2.1,6c-1.4,1.4-3.4,2.1-6,2.1H183C180.4,143,178.4,142.3,177,140.9z"/>
	</g>
            <g>
		<path class="st2" d="M218.6,122.8c0.6-0.5,1.3-0.7,2.1-0.6c2.1,0.3,3.8,0,5.2-0.9c1.4-0.8,2.2-2.3,2.4-4.3c0.2-1.6-0.2-3-1.2-4.1
			c-1-1.2-2.4-1.9-4.1-2.1c-1.7-0.2-3.3,0.2-4.8,1.2c-0.8,0.6-1.7,0.9-2.5,0.8c-0.6-0.1-1.1-0.3-1.5-0.8c-0.7-0.7-1.1-1.5-1-2.4
			c0.1-0.7,0.5-1.4,1.1-1.9c1.3-1,2.7-1.8,4.3-2.2c1.6-0.5,3.3-0.6,5-0.4c2.1,0.3,4,1,5.7,2.2c1.6,1.2,2.9,2.7,3.7,4.6
			c0.8,1.8,1.1,3.8,0.9,5.8c-0.4,3-1.5,5.3-3.5,6.9c-1.9,1.6-4.4,2.4-7.3,2.5c-0.2,0-0.3,0.1-0.3,0.2l-0.2,1.8
			c-0.1,0.8-0.4,1.5-1.1,2c-0.6,0.5-1.3,0.7-2.1,0.6c-0.8-0.1-1.5-0.5-1.9-1.1c-0.5-0.6-0.7-1.3-0.6-2.2l0.4-3.6
			C217.7,124,218,123.3,218.6,122.8z M216.4,139.1c-0.4-0.5-0.6-1.3-0.5-2.2l0.1-0.8c0.1-0.9,0.4-1.6,1-2c0.5-0.4,1.3-0.6,2.2-0.5
			l0.6,0.1c0.9,0.1,1.6,0.4,2,1c0.4,0.5,0.6,1.3,0.5,2.2l-0.1,0.8c-0.1,0.9-0.4,1.6-1,2c-0.5,0.4-1.3,0.6-2.2,0.5l-0.6-0.1
			C217.5,140,216.8,139.6,216.4,139.1z"/>
	</g>
            <g>
		<path class="st2" d="M146.2,108.1c0.2-0.5,0.6-0.8,1.1-1c1.3-0.5,2.2-1.2,2.7-2.1c0.6-0.9,0.6-2,0.1-3.2c-0.4-1-1-1.6-2-2
			c-0.9-0.4-1.9-0.4-3,0c-1.1,0.4-1.9,1.1-2.4,2.1c-0.3,0.6-0.7,1-1.2,1.2c-0.4,0.1-0.7,0.1-1.1,0c-0.6-0.2-1.1-0.6-1.3-1.1
			c-0.2-0.4-0.1-0.9,0.1-1.4c0.4-1,1-1.8,1.8-2.6c0.8-0.8,1.7-1.3,2.8-1.7c1.3-0.5,2.6-0.6,3.9-0.4c1.3,0.2,2.5,0.7,3.5,1.5
			c1,0.8,1.8,1.9,2.3,3.1c0.7,1.9,0.7,3.5,0.1,5c-0.7,1.5-1.8,2.7-3.5,3.6c-0.1,0.1-0.1,0.1-0.1,0.2l0.4,1.1c0.2,0.5,0.2,1,0,1.5
			c-0.2,0.5-0.6,0.8-1.1,1c-0.5,0.2-1,0.2-1.4,0c-0.5-0.2-0.8-0.6-1-1.1l-0.8-2.2C146,109,146,108.5,146.2,108.1z M149.8,118.1
			c-0.4-0.2-0.7-0.6-0.9-1.1l-0.2-0.5c-0.2-0.6-0.2-1,0-1.5c0.2-0.4,0.6-0.7,1.1-0.9l0.4-0.1c0.6-0.2,1-0.2,1.5,0
			c0.4,0.2,0.7,0.6,0.9,1.1l0.2,0.5c0.2,0.6,0.2,1,0,1.5c-0.2,0.4-0.6,0.7-1.1,0.9l-0.4,0.1C150.7,118.3,150.2,118.3,149.8,118.1z"
        />
	</g>
</g>
</svg>

</template>

<script>
    export default {

    };
</script>

<style lang="scss" scoped>
    svg {
        max-width: 400px;
    }

    .st0{fill:#A5A5A5;}
    .st1{fill:#D3D3D3;}
    .st2{fill:#37474F;}
    .st3{fill:#F0F0F0;}
    .st4{fill:#E5A80E;}
    .st5{fill:#BD7D59;}
    .st6{fill:#FFC109;}
    .st7{fill:#A97150;}
    .st8{fill:#F7B68D;}
    .st9{fill:#E6AA85;}
    .st10{fill:#DADADA;}
    .st11{fill:#FFFFFF;}
    .st12{fill:#FAFAFA;}
    .st13{fill:#F6F6F6;}
    .st14{fill:#FFCC66;}
    .st15{fill:#1D1D1B;}
    .st16{fill:#FF5E5A;}
    .st17{fill:#DADADA;stroke:#36474F;stroke-width:5;stroke-miterlimit:10;}
    .st18{fill:#F6F6F6;stroke:#36474F;stroke-width:5;stroke-linecap:round;stroke-miterlimit:10;}
    .st19{fill:#36474F;}
    .st20{fill-rule:evenodd;clip-rule:evenodd;fill:#36474F;}
    .st21{fill-rule:evenodd;clip-rule:evenodd;fill:#D1D1D1;}
    .st22{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
    .st23{fill-rule:evenodd;clip-rule:evenodd;fill:#FFC208;}
    .st24{fill-rule:evenodd;clip-rule:evenodd;fill:#FFDE7D;}
    .st25{filter:url(#Adobe_OpacityMaskFilter);}
    .st26{clip-path:url(#SVGID_3_);fill:#FFFFFF;}
    .st27{clip-path:url(#SVGID_3_);}
    .st28{mask:url(#SVGID_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
    .st29{fill-rule:evenodd;clip-rule:evenodd;fill:#D6A100;}
    .st30{fill:#EDEDED;}
    .st31{fill:#363F48;}
    .st32{fill:#E3E3E3;}
    .st33{fill:#C6C6C6;}
    .st34{fill:#D3A85B;}
    .st35{opacity:0.2;}
    .st36{fill:#D6D6D6;}
    .st37{opacity:0.5;fill:#404040;}
    .st38{opacity:0.6;}
    .st39{clip-path:url(#SVGID_7_);}
    .st40{clip-path:url(#SVGID_9_);}
    .st41{fill:#526A9A;}
    .st42{opacity:0.2;fill:#F0F0F0;}
    .st43{opacity:0.2;fill:#231F20;}
    .st44{fill:#AEAEAF;}
    .st45{fill:#8B8B8B;}
    .st46{opacity:0.35;fill:#231F20;}
    .st47{fill:#C0C0C0;}
    .st48{fill:#B1B1B1;}
    .st49{fill:#7E7E7E;}
    .st50{fill:#E4E4E6;}
    .st51{fill:#D2D2D2;}
    .st52{fill:#B9B8B9;}
    .st53{opacity:0.2;fill:#D92150;}
    .st54{opacity:0.2;fill:#4A0659;}
    .st55{fill:#003E61;}
    .st56{opacity:0.2;fill:#003E61;}
    .st57{opacity:0.8;fill:#FFC109;}
    .st58{opacity:0.6;fill:#FFC109;}
    .st59{fill:none;stroke:#37474F;stroke-width:1.0749;stroke-miterlimit:10;}
    .st60{opacity:0.8;fill:#37474F;}
    .st61{opacity:0.6;fill:#37474F;}
    .st62{fill:none;stroke:#FFC109;stroke-width:1.0749;stroke-miterlimit:10;}
</style>
